// @flow

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Alert from 'react-s-alert';
import {Icon} from 'react-fa';

import TreeItemDir from './TreeItemDir.jsx';
import App from './App.jsx';

import {noop, mk_title, abrev, takeDir, scroll} from './utils.js';
import {fetch_shp} from './fetch_things.js';
import {T_CULTI, T_MAV} from './codtype.js';

import type {T_Next, T_Item} from './types.js';
import type {T_ShpFile} from './Shp.js';
import type {TreeItem} from './TreeItem.js';


/* eslint-disable no-use-before-define */

export type T_OpenNextShp = (item_shp: ?TreeItemShp) => void;

/* eslint-enable no-use-before-define */


type T_TreeItemShpProps = {
  node       : T_Item,
  indent     : number,
  parent_item: TreeItemDir,
  disabled   : boolean,
  app        : App
};


type T_TreeItemShpState = {
  show_menu : boolean,
  hilight_fm: boolean,    // highlight para señalar que se hizo click derecho sobre el item
  hilight   : boolean,    // highlight para señalar que es el shape activo en el mapa
  Loaded    : boolean
};


export type T_CloseOpts = {
  next_is_mav: boolean
};




export default class TreeItemShp extends Component<T_TreeItemShpProps, T_TreeItemShpState> implements TreeItem {
  click : (ev: SyntheticMouseEvent<*>) => void;
  rclick: (ev: SyntheticMouseEvent<*>) => void;
  
  
  constructor(props: T_TreeItemShpProps) {
    super(props);
    
    this.state = {
      show_menu : false,
      hilight_fm: false,
      hilight   : false,
      Loaded    : false
    };
    
    this.click  = this.click.bind(this);
    this.rclick = this.rclick.bind(this);
  }
  
  
  
  get_path(): string {
    return this.props.node.Path;
  }
  
  
  
  get_file(): string {
    return this.props.node.File;
  }
  
  
  
  is_Mav(): boolean {
    return this.props.node.File.indexOf('mav_') === 0;
  }
  
  
  
  open(next: T_Next = noop): void {
    if (this.state.Loaded) {
      return next(false);
    }
    
    fetch_shp(this.props.app, this.props.node.Path, (response) => {
      if (typeof response === 'string') {
        Alert.error(response);
        return next(false);
      }
      
      const shp = (response: T_ShpFile);
      
      this.setState({hilight: this.props.node.Cod === T_CULTI}, () => {
        this.props.app.map_ui.show_shp(shp, () => {
          this.setState({Loaded: true}, () => next(true));
        });
      });
    });
  }
  
  
  
  hilight(): void {
    if (this.props.node.Cod === T_CULTI) {
      this.setState({hilight: true});
    }
  }
  
  
  
  close(next: T_Next = noop, opt?: T_CloseOpts): void {
    if (! this.state.Loaded) {
      return next(false);
    }
    
    const {app} = this.props;
    
    const close_shp = (): void => {
      app.map_ui.close_shp(this.props.node.Path, () => {
        this.setState({Loaded: false, hilight_fm: false}, () => {
          next(true);
        });
      });
    };
    
    const close_img_shp = (): void => {
      const img = app.map_ui.map.last_img(takeDir(this.props.node.Path));
      
      if (img) {
        const item_png = app.get_item_png(img.obj.img_filepath);
        
        if (item_png != null) {
          item_png.close(close_shp);
        }
      }
      else {
        close_shp();
      }
    };
    
    if (! app.map_ui.map.on_view_port(this.props.node.Path)) {
      return app.map_ui.change_culti(this.props.node.Path, next, true, true);
    }
    
    if (app.state.sen != null) {
      const item_sen = app.get_item_sen(app.state.sen.path);
      
      if (item_sen != null) {
        item_sen.close();
      }
      
      app.setState({sen: null});
    }
    
    this.setState({hilight: false}, () => {
      if (this.props.node.Cod === T_CULTI) {
        close_img_shp();
      }
      else if (this.props.node.Cod === T_MAV) {
        if (opt && opt.next_is_mav) {
          close_shp();
        }
        else {
          const item_culti = this.props.parent_item.shps.find(item => item.props.node.Cod === T_CULTI);
          
          if (item_culti != null) {        // NOTE: A PETICIÓN DE SANDRA G, CUANDO SE CIERRA UN MAV,
            item_culti.open(close_shp);    // SE DEBE ABRIR SU CULTI.
          }
          else {
            close_shp();
          }
        }
      }
      else {
        close_shp();
      }
    });
  }
  
  
  
  toggle(next: T_Next = noop): void {
    if (this.props.disabled) {
      return;
    }
    
    if (! this.state.Loaded) {
      this.open(next);
    }
    else {
      this.close(next);
    }
  }
  
  
  
  click(ev: SyntheticMouseEvent<*>): void {
    ev.stopPropagation();
    
    if (this.props.app.toolbar && !!this.props.app.toolbar.state.show_tabla_oport) {
      this.props.app.toolbar.setState({ show_tabla_oport: false });
    }
    
    if (ev.button === 0) {
      this.toggle();
    }
  }
  
  
  
  rclick(ev: SyntheticMouseEvent<*>): void {
    const {File}   = this.props.node,
          is_culti = File.indexOf('cultivable_') === 0,
          is_mav   = File.indexOf('mav_') === 0,
          {app}    = this.props;
    
    if (app.can_admin_file(this.props.node)) {
      if ((app.agrosat_user && is_culti) || is_mav) {  // NOTE: razón: menu recortar, borrar mav, correlaciones ms.
        app.setState({
          tree_item_menu: {
            px  : ev.pageX,
            py  : ev.pageY,
            node: this.props.node
          }
        }, () => {
          this.setState({hilight_fm: true});
        });
      }
    }
  }
  
  
  
  refresh(next: T_Next = noop): void {
    const Loaded = this.props.app.map_ui.map.is_loaded(this.props.node.Path);
    
    if (Loaded !== this.state.Loaded) {
      const new_state = {Loaded, hilight: false};
      
      if (! new_state.hilight) {
        delete new_state.hilight;
      }
      
      this.setState(new_state, () => next(true));
    }
    else {
      next(false);
    }
  }
  
  
  
  scroll(): void {
    this.props.parent_item.open_parents(() => {
      scroll(ReactDOM.findDOMNode(this));
    });
  };
  
  
  
  unclick(): void {
    if (this.state.Loaded) {
      this.setState({Loaded: false});
    }
  }
  
  
  
  render() {
    const {Loaded} = this.state,
          lb_style = {
            fontWeight: Loaded ? 'bold' : 'normal',
            color: 'black',
            border: '0',
            paddingRight: 0,
            paddingLeft: 0
          },
          cls = `treeItem${this.state.hilight && Loaded ? ' hilight' : ''}`,
          indent = {marginLeft: 15 * this.props.indent},
          tooltip = this.props.node.Unpub && this.props.node.Days ? {title: `En revisión desde hace ${this.props.node.Days} días`} : {};
    
    if (this.props.node.Unpub) {
      lb_style.color = 'red';
    }
    
    if (this.state.hilight_fm) {
      lb_style.border = '1px solid red';
      lb_style.paddingRight = 3;
      lb_style.paddingLeft = 3;
    }
    
    return (
      <div>
        <div style={indent} className={cls} onClick={this.click} onContextMenu={this.rclick} {...tooltip}>
          <Icon
            name={
              this.props.node.Unpub && ! this.props.app.agrosat_user ?
                'frown-o'
              :
                (Loaded ? 'check-square-o' : 'square-o')
            }
          />
          
          <span style={lb_style}>
            {mk_title(abrev(this.props.node.label, 40))}
          </span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/TreeItemShp.jsx